export default __webpack_public_path__ + "static/media/7.51a1ed0c.jpg";